import React, { useRef } from "react";

import ContextMenuButton from "./ContextMenuButton";
import NodeTypeLabel from "./NodeTypeLabel";
import OutputLabel from "./OutputLabel";

import { useWorkflow } from "@/components/Workflows/WorkflowCanvas/workflow-context";
import { BlockType, WorkflowNodeStatus } from "@/components/Workflows/types";

interface NodeHeaderProps {
  type: BlockType;
  isOutput?: boolean;
  nodeStatus?: WorkflowNodeStatus;
  iconBackgroundColor: string;
  iconTextColor: string;
}

const NodeHeader: React.FC<NodeHeaderProps> = ({
  type,
  isOutput,
  nodeStatus,
  iconBackgroundColor,
  iconTextColor,
}) => {
  const { readonly } = useWorkflow();
  const header = useRef<HTMLDivElement>(null);

  return (
    <div ref={header} className="flex w-full flex-row items-center justify-between px-4">
      <NodeTypeLabel
        type={type}
        iconBackgroundColor={iconBackgroundColor}
        iconTextColor={iconTextColor}
      />
      <div className="flex items-center">
        {isOutput && <OutputLabel nodeStatus={nodeStatus} />}
        {!readonly && (
          <ContextMenuButton iconBackgroundColor={iconBackgroundColor} headerRef={header} />
        )}
      </div>
    </div>
  );
};

export default NodeHeader;
